export default {
    url: '',
    template: '<courses-fields-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/fields/list/index.js